import { Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { ListItemBox } from "lib/@components/ListItemBox"
import { AuthoringRecommendationRowActions } from "./authoring-recommendation-row-actions"
import { AuthoringRecommendationRowMeta } from "./authoring-recommendation-row-meta"

export function AuthoringRecommendationRowView({
    item,
    rowStyles,
    applyDisabled,
    onSelect,
    onHover,
    onLeave,
    onOpenSource,
    onApply,
    stateLabel,
    stateColor,
    stateVariant,
    criticality,
}) {
    return (
        <ListItemBox
            onClick={onSelect}
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
            sx={rowStyles}
            data-cy={`authoring-recommendation-row-${item?.id || "unknown"}`}
        >
            <Stack spacing={1} sx={{ flex: 1, minWidth: 0, pt: 1, pb: 1.5, pl: 1.5, pr: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                    <Typography variant="subtitle2" sx={{ flex: 1, minWidth: 0, pr: 1 }}>
                        {item?.changeLabel || "Recommendation"}
                    </Typography>
                    <AuthoringRecommendationRowActions
                        routeTo={item?.routeTo}
                        applyDisabled={applyDisabled}
                        onOpenSource={onOpenSource}
                        onApply={onApply}
                    />
                </Stack>
                <AuthoringRecommendationRowMeta
                    sourceLabel={item?.sourceLabel}
                    stateLabel={stateLabel}
                    stateColor={stateColor}
                    stateVariant={stateVariant}
                    criticality={criticality}
                />
                <Typography variant="body2" color="text.primary">
                    {item?.targetLabel || "Schedule change"}
                </Typography>
                <If value={Boolean(item?.rationale)}>
                    <Typography variant="body2" color="text.secondary">
                        {item.rationale}
                    </Typography>
                </If>
            </Stack>
        </ListItemBox>
    )
}
